module.exports = __webpack_public_path__ + "img/d486b07.png";